import { formatDateForAPI } from "@utils/datetime";

export const getDelayManagement =
  (fetch: Client.HttpClient) => (filters: Sentinel.DelayManagement.Filters) => {
    const params = new URLSearchParams();
    const initialDate =
      filters.initialDate && formatDateForAPI(filters.initialDate);
    const finalDate = filters.finalDate && formatDateForAPI(filters.finalDate);
    if (initialDate) params.append("InitialDate", initialDate);
    if (finalDate) params.append("FinalDate", finalDate);
    filters.channels.forEach((value) => {
      params.append("Channel", value);
    });
    filters.processDefinitionIds.forEach((value) => {
      params.append("ProcessDefinitionId", String(value));
    });
    filters.statuses.forEach((value) => {
      params.append("Status", value);
    });
    filters.hasOpenedIncidents.forEach((value) => {
      params.append("HasOpenedIncident", value);
    });
    if (filters.incidentNumber)
      params.append("IncidentNumber", filters.incidentNumber);
    params.append("Page", String(filters.page));
    params.append("Size", String(filters.size));
    return fetch.get<Sentinel.DelayManagement.Response>(
      `/api/delay/management?${params.toString()}`
    );
  };
